import type { TriggerEventParams } from '@unifyapps/defs/hooks/useBlockEvents';
import type { BlockId } from '@unifyapps/defs/types/block';
import type { InterfaceStoreStateGetterAndSetter } from '../types';

export type PanicClickPopupData = {
  blockId: BlockId;
  eventLabel: string;
  hasActiveInteraction: boolean;
} | null;

export type PanicClickState = {
  popup: PanicClickPopupData;
  awaitingBlockId: BlockId;
  capturedEmitParams: Record<string, Omit<TriggerEventParams, 'doAction' | 'instanceId'>> | null;
};

export type PanicClickActionProps =
  | {
      operation: 'SET_PANIC_CLICK_POPUP';
      payload: PanicClickPopupData;
    }
  | {
      operation: 'SET_CAPTURED_PARAMS';
      payload: {
        blockId: string;
        params: Omit<TriggerEventParams, 'doAction' | 'instanceId'>;
      } | null;
    }
  | {
      operation: 'SET_AWAITING_BLOCK_ID';
      payload: BlockId;
    }
  | {
      operation: 'RESET_PANIC_CLICK';
      payload: null;
    };

const getPanicClickActions =
  (storeArgs: InterfaceStoreStateGetterAndSetter) =>
  ({ operation, payload }: PanicClickActionProps) => {
    const { set } = storeArgs;

    switch (operation) {
      case 'SET_PANIC_CLICK_POPUP': {
        set((state) => ({ panicClick: { ...state.panicClick, popup: payload } }));
        break;
      }
      case 'SET_CAPTURED_PARAMS': {
        set((state) => ({
          panicClick: {
            ...state.panicClick,
            capturedEmitParams: payload ? { [payload.blockId]: payload.params } : null,
          },
        }));
        break;
      }
      case 'SET_AWAITING_BLOCK_ID': {
        set((state) => ({ panicClick: { ...state.panicClick, awaitingBlockId: payload } }));
        break;
      }
      case 'RESET_PANIC_CLICK': {
        set((state) => ({
          panicClick: {
            ...state.panicClick,
            popup: payload,
            awaitingBlockId: payload,
            capturedEmitParams: payload,
          },
        }));
        break;
      }
      default:
        break;
    }
  };

export default getPanicClickActions;
